<div [class]="'search-wrapper ' + iconPlacement" [class.light]="lightTheme">
  <i class="icon" class="fas fa-search"></i>
  <input type="text" class="section-header-search" [placeholder]="searchPlaceholder" (keyup)="onKeyUp($event)">
</div>
